import FormField from './field';

export default class HighValueLeads extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.el = el;
        this.bind();
    }

    bind() {
        this.parent.addEventListener('onResult', (result) => {
            if (result.success) {
                this.api = this.el.dataset.api;
                fetch(this.api, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    credentials: 'include',
                    body: new URLSearchParams(new FormData(this.form.form)).toString(),
                });
            }
        });
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_high_value_lead');
    }
}
